<template>
  <button
    :style="{
      width: `${width}px`,
    }"
    :class="[
      'elst-button-submit',
      {
        'is-round': round,
        'is-big': size == 'big',
      },
    ]"
    @click="handle"
    v-if="show"
  >
    {{ text || $t('button_common_hand_in') }}
  </button>
</template>

<script>
export default {
  name: 'buttonSubmit',
  props: {
    handle: {
      type: Function,
      default: () => {},
    },
    show: {
      type: Boolean,
      default: true,
    },
    text: {
      type: String,
      default: '',
    },
    round: Boolean,
    // big
    size: {
      type: String,
    },
    width: {
      type: [Number, String],
      default: 180,
    },
  },
}
</script>

<style lang="scss" scoped>
.elst-button-submit {
  min-width: 180px;
  height: 44px;
  border-radius: 8px;
  background: #FAAE56;
  border: none;
  outline: none;
  color: #fff;
  font-size: 18px;
  &.is-round {
    border-radius: 8px;
  }
  &.is-big {
    height: 50px;
    &.is-round {
      border-radius: 8px;
    }
  }
  &:hover {
    opacity: 0.8;
  }
  &:active {
    opacity: 0.9;
  }
}
</style>
